import { StrictMode, ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './lib/AuthProvider'
import { CurrencyProvider } from './context/CurrencyContext'
import { StripeProvider } from './context/StripeContext'
import { PostHogProvider } from 'posthog-js/react'
import App from './App.tsx'
import './index.css'

// Conditional wrapper for StrictMode
const ConditionalStrictMode = ({ children }: { children: ReactNode }) => {
  // Enable StrictMode in development when:
  // 1. Environment variable is set to 'true', OR
  // 2. URL contains '?strict=true'
  const enableStrictMode = import.meta.env.DEV && (
    import.meta.env.VITE_ENABLE_STRICT_MODE === 'true' ||
    new URLSearchParams(window.location.search).get('strict') === 'true'
  );
  
  return enableStrictMode ? (
    <StrictMode>{children}</StrictMode>
  ) : (
    <>{children}</>
  );
};

createRoot(document.getElementById("root")!).render(
  <ConditionalStrictMode>
    <HelmetProvider>
      <AuthProvider>
        <CurrencyProvider>
          <StripeProvider>
            <PostHogProvider
              apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
              options={{
                api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
                defaults: '2025-05-24',
                capture_exceptions: true,
                debug: import.meta.env.VITE_APP_ENVIRONMENT === 'development',
              }}
            >
              <App />
            </PostHogProvider>
          </StripeProvider>
        </CurrencyProvider>
      </AuthProvider>
    </HelmetProvider>
  </ConditionalStrictMode>
);